import {usePreviewContext} from "../../context/PreviewContext";
import Typography from "@mui/material/Typography";
import {metaDataProperty} from "../preview/previewMetaData";
import React from "react";

export interface HeadlineProps {
    title?: string | null,
    variant?: 'h3' | 'h4' | 'h6', // Kann bei Bedarf erweitert werden
    propertyName?: string,
    textAlign: 'left' | 'center' | 'right',
    sx?: any,
    className?: string,
    metadataId?: string
}

function CCOHeadlineAsText(props: HeadlineProps) {
    const isPreview = usePreviewContext().isPreview;

    return props.title && props.title.length > 0 ? (
        <Typography
            className={props.className}
            variant={props.variant || 'h6'}
            component="p"
            {...metaDataProperty(isPreview, props.propertyName, props.metadataId)}
            sx={[{
                textAlign: props.textAlign
            }, props.sx]}>
            {props.title}
        </Typography>
    ) : null;
}


export default CCOHeadlineAsText